// @ts-ignore
import { Eclipse } from 'react-loading-io';
import styles from './PageLoadingFallback.module.css';

export default function PageLoadingFallback() {
  return (
    <main className={styles.fallback}>
      <Eclipse size={64} />
    </main>
  );
}
